import { render } from "./GuardianThreadList.vue?vue&type=template&id=5879f42a&scoped=true"
import script from "./GuardianThreadList.vue?vue&type=script&lang=js"
export * from "./GuardianThreadList.vue?vue&type=script&lang=js"

import "./GuardianThreadList.vue?vue&type=style&index=0&id=5879f42a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5879f42a"]])

export default __exports__